import { drawerComponent as DrawerComponent } from '../../scripts/drawer';
import { CartAddEvent } from '../../entries/scripts/events';

if (!customElements.get('cart-drawer')) {
  class CartDrawer extends DrawerComponent {
    connectedCallback() {
      super.connectedCallback();
      document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    }

    #handleCartAdd = (event) => {
      const didError = event.detail.data.didError || false;
      if (this.hasAttribute('auto-open') && !didError) {
        this.open();
      }
    };

    open() {
      this.details.open = true;
    }

    /**
     * Gets the section id.
     * @returns {string} The section id.
     */
    get sectionId() {
      const { sectionId } = this.dataset;

      if (!sectionId) throw new Error('Section id missing');

      return sectionId;
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}
